<script setup lang="ts">
  defineProps<{
    title: string;
  }>();
</script>

<template>
  <div class="flex items-center justify-between p-4 border-b-2 border-white/10">
    <slot name="icon"></slot>
    <span class="text-white font-bold text-[34px] font-barlow">{{ title }}</span>
  </div>
</template>
